export enum EmailDialogType {
    benefitSummary = "benefitSummary",
    payStub = "payStub",
    annualStatement = 'annualStatement',
    form1095 = 'form1095',
    w2 = 'w2'
}